import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { RETAILER_AVAILABLE_LOCALES } from "@faire/web-api--source/indigofair/settings/RETAILER_AVAILABLE_LOCALES";
export var getSettingRetailerAvailableLocales = function() {
    return getSettingValueWithoutAssignment(RETAILER_AVAILABLE_LOCALES, [
        {
            language: Language.ENG,
            country: undefined
        }
    ]);
};
